import { __decorate } from "tslib";
import { AutoEncoder, EnumDecoder, field } from '@simonbackx/simple-encoding';
import { SessionEnvironment } from './SessionEnvironment';
/**
 * Response body for GET /session/environment, and also used as the request
 * body for POST /session/environment (the client sends the environment it
 * wants; the server decides whether that's allowed and echoes back what's
 * actually now in effect).
 */
export class EnvironmentStatus extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.environment = SessionEnvironment.Production;
    }
}
__decorate([
    field({ decoder: new EnumDecoder(SessionEnvironment) })
], EnvironmentStatus.prototype, "environment", void 0);
//# sourceMappingURL=EnvironmentStatus.js.map